module.exports = new __parcel__URL__("sat-data-agriculture--discovery-cover.436ac6ef.jpg").toString();